import { synaesthetik } from "./synaesthetik";
import { runawayProject } from "./runawayProject";
import { mutZurWut } from "./mutZurWut";
import { pixedCloud } from "./pixedCloud";
import { blackMonday } from "./blackMonday";
import { unstuck } from "./unstuck";
import { panamaPapers } from "./panamaPapers";
// import { sempreAlDente } from "./sempreAlDente";
import { koform } from "./koform";
import { gallusTheater } from "./gallusTheater";
import { selectedPosters } from "./selectedPosters";

export const projects = [
  synaesthetik,
  blackMonday,
  runawayProject,
  unstuck,
  mutZurWut,
  panamaPapers,
  // sempreAlDente,
  koform,
  gallusTheater,
  pixedCloud,
  selectedPosters,
];
